import React, { Component } from 'react';
import PropTypes from 'prop-types';
import addressActions from '../../actions/addressActions';
import paymentActions from '../../actions/paymentActions';
import klikkieLogo from '../../img/klikkie-logo.png';
import CountryUtils from '../../utils/CountryUtils';
import { formatPrice } from '../../utils/CurrencyUtils';
import './Invoice.scss';
import i18next from '../../services/i18n';

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: {},
      currency: '',
      products: {},
      address: '',
      payment: {},
      loaded: false,
    };
  }

  async componentDidMount() {
    const { order } = this.props;
    try {
      await paymentActions.getUserPayment(order.id).then((result) => this.setState({ payment: result }));
      addressActions.getAddress(order.userId, order.invoiceAddressId).then((result) => {
        this.setState({
          order,
          products: order.products,
          currency: order.currency,
          address: result,
          loaded: true,
        });
      }).catch(() => {
        this.setState({
          order,
          products: order.products,
          currency: order.currency,
          loaded: true,
        });
      });
    } catch (error) {
      console.info(error);
      this.setState({ loaded: true });
    }
  }

  componentWillUnmount() {
    this.setState({ loaded: false });
  }

  convertPrice(price) {
    const { currency } = this.state;
    return formatPrice(price, currency);
  }

  render() {
    const { order, products, address, payment, loaded } = this.state;
    const updatedAt = new Date(order.updatedAt).toLocaleDateString();
    if (!loaded) {
      return false;
    }
    return (
      <div className="invoiceContainer">
        <section className="invoicePage">
          <div className="invoiceHeader">
            <div className="address">
              <img className="logo" src={klikkieLogo} alt="logo" />
              <div className="address-line">klikkie BV</div>
              <div className="address-line">Herengracht 577</div>
              <div className="address-line">1017 CD Amsterdam</div>
              <div className="address-line">The Netherlands</div>
              <div className="address-line">VAT NL 8576 14289 B01</div>
            </div>
            <div className="date">
              <div className="date-line">{`${i18next.t('Invoices.invoice.date')} ${new Date().toLocaleDateString()}`}</div>
              <div className="date-line">{`${i18next.t('Invoices.invoice.order.date')} ${updatedAt}`}</div>
            </div>
          </div>
          <table className="order">
            <tbody>
              <tr className="title">
                <td colSpan="2">
                  <h4>
                    order: {order.id}
                  </h4>
                </td>
              </tr>
              <tr />
              {order &&
                Object.keys(products).map((product) => (
                  <tr key={product}>
                    <td className="product-info">
                      {products[product].units} x <span className="uppercase">{products[product].name}</span>
                      <small>{products[product].units > 1 && this.convertPrice(products[product].unitPrice)}</small>
                    </td>
                    <td className="product-price">{this.convertPrice(products[product].total)}</td>
                  </tr>
                ))}
              {order.totalDiscount > 0 && (
                <>
                  <tr>
                    <td className="colorSpan">Total Discount:</td>
                    <td className="price">{this.convertPrice(order.totalDiscount)}</td>
                  </tr>
                  <tr>
                    <td className="colorSpan">Total Pre Discount:</td>
                    <td className="price">{this.convertPrice(order.totalPreDiscount)}</td>
                  </tr>
                </>
              )}
              {order.totalPrepaid > 0 && (
                <tr>
                  <td className="colorSpan">Total Pre Paid:</td>
                  <td className="price">{this.convertPrice(order.totalPrepaid)}</td>
                </tr>
              )}
              <tr>
                <td className="colorSpan">{i18next.t('Invoices.invoice.shipping')}:</td>
                <td className="price">{this.convertPrice(order.totalShipping)}</td>
              </tr>
              <tr className="total">
                <td className="colorSpan">{i18next.t('Invoices.invoice.total')}:</td>
                <td className="price">{this.convertPrice(order.totalToCharge)}</td>
              </tr>
              <tr>
                <td className="colorSpan">{i18next.t('Invoices.invoice.vat')}:</td>
                <td className="price">{this.convertPrice(order.totalVat)}</td>
              </tr>
            </tbody>
          </table>
          {payment && (
            <table className="payment">
              <tbody>
                <tr className="title">
                  <td colSpan="2">
                    <h4>{i18next.t('Invoices.invoice.title.payment')} </h4>
                  </td>
                </tr>
                <tr>
                  <td className="payment-method">
                    <span className="colorSpan">{`${i18next.t('Invoices.invoice.paymentMethod')}:`}</span>
                    {payment.paymentMethod || 'undefined'}
                  </td>
                  <td className="payment-date">
                    <span className="colorSpan">{`${i18next.t('Invoices.invoice.paymentDate')}:`}</span>
                    {new Date(payment.updatedAt).toLocaleDateString()}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          {address && (
            <table className="address">
              <tbody>
                <tr className="title">
                  <td colSpan="2">
                    <h4>{i18next.t('Invoices.invoice.title.address')} </h4>
                  </td>
                </tr>
                <tr>
                  <td className="address-content">
                    <div className="address-line">{address.fullname || address}</div>
                    <div className="address-line">{address.address}</div>
                    <div className="address-line">{address.address2}</div>
                    <div className="address-line">{address.region}</div>
                    <div className="address-line">{address.zipcode}</div>
                    <div className="address-line">{address.city}</div>
                    <div className="address-line">{CountryUtils.getCountryFromCountryCode(address.countryCode)}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </section>
      </div>
    );
  }
}
Invoice.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  order: PropTypes.object.isRequired,
};

export default Invoice;
